import { confirmDialog } from "primereact/confirmdialog";
import {
  createProjectCategory,
  deleteProjectCategory,
  updateProjectCategory,
  getAllProjectCategories,
  getProjectCategory,
} from "../../services/ValitanApiService";
import { enqueueSnackbar } from "notistack";

// Fetch Project Categories
export const getProjectCategories = async (page = 0, size = 10) => {
  try {
    const response = await getAllProjectCategories(page, size);
    const data = response.data;

    if (response.status === 200 && Array.isArray(data.content)) {
      return {
        projectCategories: data.content,
        paginationInfo: {
          totalElements: data.total_elements ?? 0,
          totalPages: data.total_pages ?? 0,
          pageNumber: data.number ?? 0,
          pageSize: data.size ?? size,
          sort: data.sort ?? {},
        },
      };
    } else {
      enqueueSnackbar("Failed to fetch project categories.", { variant: "error" });
      return { projectCategories: [], paginationInfo: {} };
    }
  } catch (error) {
    enqueueSnackbar("Error fetching project categories. Please try again.", {
      variant: "error",
    });
    return { projectCategories: [], paginationInfo: {} };
  }
};

// Delete Project Category
export const deleteAProjectCategory = async (id, loadProjectCategories) => {
  try {
    const response = await deleteProjectCategory(id);
    if (response.data.status === "success") {
      enqueueSnackbar(response.data.message, { variant: "success" });
      await loadProjectCategories();
    } else {
      enqueueSnackbar(response.data.message || "Failed to delete project category.", { variant: "error" });
    }
  } catch (error) {
    enqueueSnackbar("Failed to delete project category. Please try again.", { variant: "error" });
    console.error(error);
  }
};

export const confirmDelete = (id, loadProjectCategories) => {
  confirmDialog({
    message: "Are you sure you want to delete this project category?",
    header: "Confirmation",
    icon: "pi pi-question-circle",
    accept: () => deleteAProjectCategory(id, loadProjectCategories),
    reject: () => { },
  });
};

// Validation
export const validateProjectCategoryForm = (
  projectCategoryName,
  projectCategoryDescription,
  projectCategoryCode,
  setErrors
) => {
  let valid = true;
  const errorsCopy = {
    projectCategoryName: "",
    projectCategoryDescription: "",
    projectCategoryCode: "",
  };

  if (!projectCategoryName.trim()) {
    errorsCopy.projectCategoryName = "Name is required";
    valid = false;
  }
  if (!projectCategoryDescription.trim()) {
    errorsCopy.projectCategoryDescription = "Description is required";
    valid = false;
  }
  if (!projectCategoryCode.trim()) {
    errorsCopy.projectCategoryCode = "Code is required";
    valid = false;
  } else if (!/^[A-Za-z0-9_-]{2,50}$/.test(projectCategoryCode.trim())) {
    errorsCopy.projectCategoryCode = "2–50 chars (letters, numbers, _ or -)";
    valid = false;
  }

  setErrors(errorsCopy);
  return valid;
};

// Create or update
export const createOrUpdateProjectCategory = async (
  event,
  projectCategoryName,
  projectCategoryDescription,
  projectCategoryCode,
  editingProjectCategoryId,
  loadProjectCategories,
  toggleModal,
  setErrors
) => {
  event.preventDefault();

  if (
    !validateProjectCategoryForm(
      projectCategoryName,
      projectCategoryDescription,
      projectCategoryCode,
      setErrors
    )
  ) {
    return;
  }

  const projectCategoryData = {
    name: projectCategoryName,
    description: projectCategoryDescription,
    code: projectCategoryCode,
  };

  try {
    const response = editingProjectCategoryId
      ? await updateProjectCategory(editingProjectCategoryId, projectCategoryData)
      : await createProjectCategory(projectCategoryData);

    if (response.data.status === "success") {
      enqueueSnackbar(response.data.message, { variant: "success" });
      toggleModal();
      await loadProjectCategories();
    } else {
      enqueueSnackbar(response.data.message || "Failed to save project category data.", { variant: "error" });
    }
  } catch (error) {
    console.error("Error saving project category data:", error);
    enqueueSnackbar("Error saving project category data. Please try again.", { variant: "error" });
  }
};

// Fetch single (helper for edit modal)
export const fetchProjectCategoryForEdit = async (id) => {
  const response = await getProjectCategory(id);
  const payload = response?.data?.data || response?.data;
  return payload;
};
